var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("navigation-layout", { ref: "navigationlayout" }, [
    _c("h1", { attrs: { slot: "title" }, slot: "title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { slot: "abstract" }, slot: "abstract" }, [
      _vm._v(_vm._s(_vm.abstract))
    ]),
    _vm._v(" "),
    _vm.endLoading
      ? _c(
          "main",
          [
            _c(
              "md-tabs",
              {
                staticClass: "md-transparent",
                attrs: { "md-alignment": "fixed" }
              },
              [
                _c(
                  "md-tab",
                  { attrs: { id: "tab-chain-info", "md-label": "Chain Info" } },
                  [_c("chain-info", { attrs: { parentref: this } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "md-tab",
                  { attrs: { id: "tab-facilities", "md-label": "Facilities" } },
                  [_c("chain-facilities", { attrs: { parentref: this } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "md-tab",
                  { attrs: { id: "tab-staff", "md-label": "Staff" } },
                  [_c("chain-staff", { attrs: { parentref: this } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "md-tab",
                  {
                    attrs: {
                      id: "tab-integration-info",
                      "md-label": "Integration info"
                    }
                  },
                  [
                    _c("chain-integration-info", { attrs: { parentref: this } })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40fa778a", { render: render, staticRenderFns: staticRenderFns })
  }
}